export function parseResponsiveSizes(value) {
  const values = Array.isArray(value) ? value : String(value || "").split(",");
  return values.map(item => Array.isArray(item) ? item : String(item).trim().split("x").map(Number))
    .filter(size => size.length === 2 && size.every(n => Number.isInteger(n) && n > 0 && n <= 4096));
}
export function validateNumericSizes(input) {
  if (!Array.isArray(input) || !input.length || parseResponsiveSizes(input).length !== input.length) throw new Error("Use numeric sizes such as 300x250 or 320x50.");
  return parseResponsiveSizes(input);
}
export function normalizeResponsiveMapping(input, fallbackSizes = []) {
  const sizes = parseResponsiveSizes(fallbackSizes);
  if (!Array.isArray(input) || !input.length) {
    const widths = [...new Set(sizes.map(size => size[0]))].sort((a, b) => b - a);
    return [...widths.map(width => ({ viewport: [width, 0], sizes: sizes.filter(size => size[0] <= width) })), { viewport: [0, 0], sizes: [] }];
  }
  return input.map(row => {
    if (!Array.isArray(row.viewport) || row.viewport.length !== 2 || !row.viewport.every(n => Number.isInteger(n) && n >= 0)) throw new Error("Invalid responsive viewport.");
    if (!Array.isArray(row.sizes)) throw new Error("Invalid responsive sizes.");
    const numeric = row.sizes.length ? validateNumericSizes(row.sizes) : [];
    if (numeric.some(size => size[0] > row.viewport[0])) throw new Error("Creative width exceeds its minimum viewport.");
    if (sizes.length && numeric.some(size => !sizes.some(base => base[0] === size[0] && base[1] === size[1]))) throw new Error("Mapping size must belong to placement sizes.");
    return { viewport: [...row.viewport], sizes: numeric };
  }).sort((a, b) => b.viewport[0] - a.viewport[0]);
}
export function sizesForViewport(mapping, width, height = 10000) {
  return mapping.find(row => width >= row.viewport[0] && height >= row.viewport[1])?.sizes || [];
}
export function reservedSlotDimensions(mapping) {
  const sizes = mapping.flatMap(row => row.sizes);
  return sizes.length ? { width: Math.min(...sizes.map(size => size[0])), height: Math.max(...sizes.map(size => size[1])) } : { width: 0, height: 0 };
}
